import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RatingModule } from 'primeng/rating';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { UserCartService } from '../home/shared/services/user-cart.service';
import { EmployeeItem, RatingSettings } from 'src/app/core/models/rating.model';
import { TranslateModule } from '@ngx-translate/core';
import { commonService } from 'src/app/core/services/common.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-rate-company',
  standalone: true,
  imports: [
    RatingModule,
    FormsModule,
    InputTextareaModule,
    TranslateModule,
    CommonModule,
  ],
  templateUrl: './rate-company.component.html',
  styleUrl: './rate-company.component.scss',
})
export class RateCompanyComponent implements OnInit {
  @Input() id: number;
  numberOfRatedEmployees = 0;
  rate!: number;
  activePage: number = 0; // 0 : rate company, 1: rate 5 employees, 2: thanks for review
  employeesRatings: EmployeeItem[];

  numberOfEmployeesWithNonZeroRatings: number = 0;
  ratingSettings: RatingSettings;

  constructor(
    public modal: NgbModal,
    private userCartService: UserCartService,
    public common: commonService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.getRatingSettings(this.id);
  }

  getRatingSettings(id: number): void {
    this.userCartService.getRatingSettings(id).subscribe((res) => {
      this.ratingSettings = res.data;
      this.employeesRatings = res.data?.employeeItems;
    });
  }

  goToRateEmployees(): void {
    this.activePage = 1;
  }

  goToRateCompany(): void {
    this.activePage = 0;
  }

  submit(): void {
    this.userCartService.submitRating(this.ratingSettings).subscribe((res) => {
      this.modalService.dismissAll();
    });
  }

  skip(): void {
    this.userCartService.skipRating(this.id).subscribe((res) => {
      this.modalService.dismissAll();
    });
  }

  saveEmployeesRate() {
    const employeesWithNonZeroRatings = this.employeesRatings.filter(
      (employee) => employee.employeeRate !== 0
    );

    this.numberOfEmployeesWithNonZeroRatings =
      employeesWithNonZeroRatings.length;
  }
}
